import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

export default function ProductReview({ productId }) {
  const { user } = useContext(AuthContext);
  const token = localStorage.getItem("token") || "";

  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Form state
  const [name, setName] = useState(user?.name || "");
  const [rating, setRating] = useState("");
  const [comment, setComment] = useState("");

  // Fetch reviews
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get(
          `https://cartbackend.wsdstech.com/api/products/${productId}/reviews`
        );
        setReviews(res.data || []);
      } catch (err) {
        console.error("Error fetching reviews:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, [productId]);

  // Handle review submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rating || !comment || (!user && !name)) {
      alert("⚠️ Please fill all fields!");
      return;
    }

    try {
      const res = await axios.post(
        "https://cartbackend.wsdstech.com/api/reviews",
        {
          product_id: productId,
          name: user?.name || name,
          rating: Number(rating),
          comment,
        },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );

      // Update local review list
      setReviews((prev) => [res.data, ...prev]);

      // Reset form
      setRating("");
      setComment("");
      if (!user) setName("");

      alert("✅ Review submitted successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to submit review.");
    }
  };

  if (loading) return <p>⏳ Loading reviews...</p>;

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="reviewHeading">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#reviewCollapse"
          aria-expanded="false"
          aria-controls="reviewCollapse"
        >
          ⭐ Ratings & Reviews ({reviews.length})
        </button>
      </h2>

      <div
        id="reviewCollapse"
        className="accordion-collapse collapse"
        aria-labelledby="reviewHeading"
        data-bs-parent="#faqAccordion"
      >
        <div className="accordion-body">
          {/* Existing Reviews */}
          {reviews.length === 0 && <p>No reviews yet.</p>}
          {reviews.map((rev, index) => (
            <div key={index} className="mb-3 border-bottom pb-2">
              <p className="mb-1">
                <strong>{rev.name}</strong> ⭐ {rev.rating} / 5
              </p>
              <p className="mb-0">{rev.comment}</p>
            </div>
          ))}

          <hr />

          {/* Write a Review Form */}
          <h5 className="mb-3">Write a Review</h5>
          <form onSubmit={handleSubmit}>
            {!user && (
              <div className="mb-3">
                <label className="form-label">Your Name</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            )}

            <div className="mb-3">
              <label className="form-label">Rating</label>
              <select
                className="form-select"
                required
                value={rating}
                onChange={(e) => setRating(e.target.value)}
              >
                <option value="">Select rating</option>
                <option value="5">⭐⭐⭐⭐⭐ (5)</option>
                <option value="4">⭐⭐⭐⭐ (4)</option>
                <option value="3">⭐⭐⭐ (3)</option>
                <option value="2">⭐⭐ (2)</option>
                <option value="1">⭐ (1)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Your Review</label>
              <textarea
                className="form-control"
                rows="3"
                required
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>

            <button type="submit" className="btn btn-success">
              Submit Review
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
